import { FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloWelcome } from "components/views/atoms/Illustrations"
import { SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"

export const NiceToSeeYou = ({ firstName, companyName, onComplete }) => (
  <FleLayout>
    <div className="dn db-ns">
      <Spacer height={3.5} />
    </div>
    <div className="db dn-ns">
      <Spacer height={1} />
    </div>
    <FlexRowCenter>
      <IlloWelcome />
    </FlexRowCenter>
    <SpacerSwitcher />
    <SwitchH1ToH2>Nice to see you, {firstName}</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">
      {companyName} has partnered with Carrot to make fertility care and family forming more affordable and accessible
      to you.
    </Body>
    <FleLinkWrapper spacerHeight={1.5}>
      <ArrowLink onClick={onComplete}>Continue</ArrowLink>
    </FleLinkWrapper>
  </FleLayout>
)
